import DAO from './DAO.js';
import customersService from '../services/customersService';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import dataModel from '../models/DataModel';
import Metadata from '../helpers/metadata/Metadata';

export default class CustomersDAO extends DAO {

  constructor(store) {
    super(store, 'customer');
    this.unsetCustomer = this.unsetCustomer.bind(this);
    this.clearCustomers = this.clearCustomers.bind(this);
  }

  unsetCustomer(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearCustomers() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  createCustomer(customer, eventMetadatum, options) {
    return customersService.createCustomer(customer, eventMetadatum, options).then(response => {
      if (response.error) {
        dataModel.displayHTTPError('Creating a customer', response.error, false);
        this.throwItemError('Error creating a customer', response);
      }
      else {
        const newCustomer = this.normalizeAndSyncToStore(response);
        return this.mapToReturn(this.findItem(newCustomer.id), options);
      }
    })
    .catch(error => {
      throw error;
    });
  }

  updateCustomer(customer, eventMetadatum, options) {
    this.markPending(customer);
    return customersService.updateCustomer(customer, eventMetadatum, options).then(response => {
      if (response.error) {
        dataModel.displayHTTPError('Updating a customer', response.error, false);
        this.markError(customer);
        this.throwItemError();
      } 
      else {
        const updatedCustomer = this.normalizeAndSyncToStore(response);
        this.markDirty(updatedCustomer, false);
        return this.mapToReturn(this.findItem(updatedCustomer.id), options);
      }
    })
    .catch(error => {
      throw error;
    });
  }

  deleteCustomer(customerId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return customersService.deleteCustomer(customerId, eventMetadatum).then(response => {
      if (response.error) {
        dataModel.displayHTTPError('Deleting a customer', response.error, false);
        this.throwItemError();
      }
      else {
        // TODO: update company/project customers list? for now no...
        this.unsetCustomer(customerId);
        dataModel.displayInfoErrorMessage('The customer was successfully deleted.', 4000, 1);
        return true;
      } 
    });
  }

  getCustomer(customerId, options) {
    if (!options) {
      options = { recordDescriptor: { customer: {} } };
    }
    return this._getItem(customerId, customersService.getCustomer.bind(this, customerId, options), options);
  }

  getCustomers(companyId, options) {
    if (!options) {
      options = { recordDescriptor: { customer: {} } };
    }
    return customersService.getCustomers(companyId, options).then((response) => {
      if (response.error) {
        dataModel.displayHTTPError('Retrieving customers for company', response.error, false);
        this.throwItemError();
      }
      else {
        const ids = StoreItemProcessing.normalizeAndSyncCollectionToStore('customer', response);
        // TODO: set customers on company (if company in store)?
        return ids.map((customer_id) => {
          return this.mapToReturn(this.findItem(customer_id), options);
        });
      }
    })
    .catch((error) => {
      throw error;
    });
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_customers, options.toIgnore.customers, this.unsetCustomer, this.clearCustomers, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/CustomersDAO.js